import merge from 'lodash/merge'

import { useBuilder } from '@/lib/builder/extension/useBuilder'

import { type CTAButtonSection } from '../../../types'

const emailBuilderQueue = useBuilder('emailBuilder')

export const CTAButtonCommands = {
  updateBlock: emailBuilderQueue.createBlockCommand<CTAButtonSection>({
    commit: async (currentData, ctx) => merge(currentData, ctx.update),
  }),
}
